import React, { useState } from "react";
import { Upload } from "common/types/File";
import { Button, Image, Popconfirm, Progress, Tooltip } from "antd";
import { IconEye, IconTrack, IconX } from "@tabler/icons-react";
import FileModel from "common/models/FileModel";
import { FileImageFilled, FileImageOutlined } from "@ant-design/icons";
import { useDeleteImageMutation } from "features/comment/service/file.service";

type Props = {
  file: Upload;
  handleDeleteFileList: (uid: string) => void;
  handleDeleteFileDone?: ({
    error,
    res,
  }: {
    error: string;
    res: string;
  }) => void;
};
const FileUploadItem2 = ({
  file,
  handleDeleteFileList,
  handleDeleteFileDone,
}: Props) => {
  console.log("🚀 ~ file: FileUploadItem2.tsx:25 ~ file:", file);
  const [deleteImage, deleteImageResult] = useDeleteImageMutation();

  const [loading, setLoading] = useState(false);

  const myFile = new FileModel(
    typeof file.response !== "undefined" &&
    typeof file.response !== "string" &&
    file.response.id > 0
      ? file.response
      : FileModel.getDefaultData()
  );
  let com = null;
  //
  //
  const handleDelete = async (data: Upload) => {
    setLoading(true);
    if (data.response && data.response.hasOwnProperty("error") === false) {
      if (typeof data.response !== "string") {
        handleDeleteFileList(data.uid);
        handleDeleteFileDone &&
          handleDeleteFileDone({ error: "", res: "success" });
        // await deleteImage({ id: data.response.id })
        //   .then((res) => {
        //     handleDeleteFileList(data.uid);
        //     handleDeleteFileDone &&
        //       handleDeleteFileDone({ error: "", res: "success" });
        //   })
        //   .catch((error) => {
        //     handleDeleteFileDone &&
        //       handleDeleteFileDone({
        //         error: JSON.stringify(error),
        //         res: "fail",
        //       });
        //   });
      }
    } else {
      handleDeleteFileList(data.uid);
      handleDeleteFileDone &&
        handleDeleteFileDone({
          error: "error",
          res: "fail",
        });
    }
    setLoading(true);

    // handleDeleteFileList(data.uid);
  };

  ///

  switch (file.status) {
    case "uploading":
      com = (
        <Progress
          size="small"
          strokeColor={{
            "0%": "#108ee9",
            "100%": "#87d068",
          }}
          percent={file.percent}
        />
      );
      break;
    case "error":
      com = (
        <div
          style={{
            border: "1px solid red",
            borderRadius: 4,
            height: "100%",
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            cursor: "pointer",
            position: "relative",
          }}
        >
          <Popconfirm
            placement="topLeft"
            title="Xóa ảnh này"
            onConfirm={() => handleDelete(file)}
            trigger={["hover"]}
            okButtonProps={{
              style: { backgroundColor: "#D72229", color: "white" },
            }}
          >
            <span
              style={{
                backgroundColor: "white",
                position: "absolute",
                top: 0,
                right: 0,
                transform: "translate(40% ,-40%)",
                width: "20px",
                height: "20px",
                borderRadius: "100%",
                border: "1.5px solid #898889",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 20,
                cursor: "pointer",
              }}
              // onClick={() => handleDelete(file)}
            >
              <IconX
                style={{ color: "#898889", width: "16px", height: "16px" }}
              ></IconX>
            </span>
          </Popconfirm>
          {/* <span
              style={{
                backgroundColor: "white",
                position: "absolute",
                top: 0,
                right: 0,
                transform: "translate(40% ,-40%)",
                width: "20px",
                height: "20px",
                borderRadius: "100%",
                border: "1.5px solid #898889",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 20,
                cursor: "pointer",
              }}
              onClick={() => handleDelete(file)}
            >
              <IconX
                style={{ color: "#898889", width: "16px", height: "16px" }}
              ></IconX>
            </span> */}
          <FileImageOutlined
            style={{
              fontSize: 24,
              color: "red",
            }}
          />
        </div>
      );
      break;
    case "done":
      com = (
        <div
          style={{
            // border: "1px solid green",
            borderRadius: 4,
            height: "100%",
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            cursor: "pointer",
            padding: "1px",
            position: "relative",
          }}
        >
          <Popconfirm
            placement="topLeft"
            title="Xóa ảnh này"
            onConfirm={() => handleDelete(file)}
            trigger={["hover"]}
            okButtonProps={{
              style: { backgroundColor: "#D72229", color: "white" },
            }}
          >
            <span
              style={{
                backgroundColor: "white",
                position: "absolute",
                top: 0,
                right: 0,
                transform: "translate(40% ,-40%)",
                width: "20px",
                height: "20px",
                borderRadius: "100%",
                border: "1.5px solid #898889",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 20,
                cursor: "pointer",
              }}
              // onClick={() => handleDelete(file)}
            >
              <IconX
                style={{ color: "#898889", width: "16px", height: "16px" }}
              ></IconX>
            </span>
          </Popconfirm>
          <Image
            style={{ borderRadius: 4, width: "105px", height: "105px" }}
            src={myFile.getThumbnail(105, 105, "crop")}
            width={105}
            height={105}
            // onError={() => setImageError(true)}
            preview={{
              src: FileModel.getThumbnailFromUrl(
                myFile.file_path,
                1080,
                756,
                "crop"
              ),

              mask: (
                <>
                  <Tooltip title={"Xem"} trigger={["hover"]}>
                    <Button
                      size="small"
                      type="text"
                      icon={
                        <IconEye
                          size="16"
                          color="white"
                          style={{ marginRight: 5 }}
                        />
                      }
                    />
                  </Tooltip>
                  {/* <Tooltip title={"Xóa"} trigger={["hover"]}>
                      <Button
                        size="small"
                        type="text"
                        onClick={() => {
                          handleDelete(file);
                        }}
                        icon={
                          <IconTrack
                            size="16"
                            color="white"
                            style={{ marginRight: 5 }}
                          />
                        }
                      />
                    </Tooltip> */}
                </>
              ),
              maskStyle: { background: "#3A393A", opacity: "0.7" },
              maskClassName: "mask_background",
            }}
          />
        </div>
      );
      break;
    default:
      break;
  }

  return <> {com}</>;
};

export default FileUploadItem2;
